export type AppTarget = "customer" | "admin";
export type UserRole = "customer" | "admin";

export const APP_TARGET: AppTarget = import.meta.env.VITE_APP_TARGET === "admin" ? "admin" : "customer";
export const EXPECTED_ROLE: UserRole = APP_TARGET;
const LOCAL_API = APP_TARGET === "admin"
  ? "http://10.0.2.2:8000/api/v1"
  : "http://localhost:8000/api/v1";
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || LOCAL_API).replace(/\/$/, "");
export const WEB_PUSH_PUBLIC_KEY = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY || "";

export const APP_COPY = APP_TARGET === "customer"
  ? {
      title: "今晚吃什么",
      eyebrow: "ONLY FOR YOU",
      subtitle: "只为你开的小厨房",
      email: "murui",
      avatar: "👧🏻",
    }
  : {
      title: "我的小厨房",
      eyebrow: "PRIVATE KITCHEN",
      subtitle: "今天也要认真投喂她",
      email: "fanyu",
      avatar: "👨🏻‍🍳",
    };
